export const FCL_IMPORT_BOOKING_REPORT_LIST = "FCL_IMPORT_BOOKING_REPORT_LIST";
export const FCL_IMPORT_BOOKING_REPORT_SUMMARY = "FCL_IMPORT_BOOKING_REPORT_SUMMARY";
export const FCL_IMPORT_BOOKING_REPORT_SECTIONS = "FCL_IMPORT_BOOKING_REPORT_SECTIONS";

export const FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_LIST = "FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_LIST";
export const FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_SUMMARY = "FCL_IMPORT_ACTIVE_SHIPMENT_REPORT_SUMMARY";

export const FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_LIST = "FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_LIST";
export const FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_SUMMARY = "FCL_IMPORT_CONTAINER_DEMURRAGE_REPORT_SUMMARY";

export const FCL_IMPORT_TRUCKING_REPORT_LIST = "FCL_IMPORT_TRUCKING_REPORT_LIST";
export const FCL_IMPORT_TRUCKING_REPORT_SUMMARY = "FCL_IMPORT_TRUCKING_REPORT_SUMMARY";

export const FCL_IMPORT_STATUS_AUDIT_REPORT_LIST = "FCL_IMPORT_STATUS_AUDIT_REPORT_LIST";
export const FCL_IMPORT_STATUS_AUDIT_REPORT_SUMMARY = "FCL_IMPORT_STATUS_AUDIT_REPORT_SUMMARY";

export const FCL_IMPORT_CONTAINER_TRACKING_REPORT_LIST = "FCL_IMPORT_CONTAINER_TRACKING_REPORT_LIST";
export const FCL_IMPORT_CONTAINER_TRACKING_REPORT_SUMMARY = "FCL_IMPORT_CONTAINER_TRACKING_REPORT_SUMMARY";
export const FCL_IMPORT_CONTAINER_TRACKING_REPORT_PAGINATION = "FCL_IMPORT_CONTAINER_TRACKING_REPORT_PAGINATION";

export const FCL_IMPORT_ARRIVAL_NOTICE_REPORT_LIST = "FCL_IMPORT_ARRIVAL_NOTICE_REPORT_LIST";
export const FCL_IMPORT_ARRIVAL_NOTICE_REPORT_SUMMARY = "FCL_IMPORT_ARRIVAL_NOTICE_REPORT_SUMMARY";

export const FCL_IMPORT_ETA_STATUS_REPORT_LIST = "FCL_IMPORT_ETA_STATUS_REPORT_LIST";
export const FCL_IMPORT_ETA_STATUS_REPORT_SUMMARY = "FCL_IMPORT_ETA_STATUS_REPORT_SUMMARY";

export const FCL_IMPORT_FILE_CANCELLATION_REPORT_LIST = "FCL_IMPORT_FILE_CANCELLATION_REPORT_LIST";
export const FCL_IMPORT_FILE_CANCELLATION_REPORT_SUMMARY = "FCL_IMPORT_FILE_CANCELLATION_REPORT_SUMMARY";

export const FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_LIST = "FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_LIST";
export const FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_SUMMARY = "FCL_IMPORT_ARRIVAL_NOTICE_PRE_ALERT_REPORT_SUMMARY";

export const FCL_IMPORT_PROFIT_LOSS_REPORT_LIST = "FCL_IMPORT_PROFIT_LOSS_REPORT_LIST";
export const FCL_IMPORT_PROFIT_LOSS_REPORT_SUMMARY = "FCL_IMPORT_PROFIT_LOSS_REPORT_SUMMARY";
export const FCL_IMPORT_PROFIT_LOSS_REPORT_SECTIONS = "FCL_IMPORT_PROFIT_LOSS_REPORT_SECTIONS";

export const FCL_IMPORT_RATE_QUOTE_REPORT_LIST = "FCL_IMPORT_RATE_QUOTE_REPORT_LIST";
export const FCL_IMPORT_RATE_QUOTE_REPORT_SUMMARY = "FCL_IMPORT_RATE_QUOTE_REPORT_SUMMARY";
export const FCL_IMPORT_RATE_QUOTE_REPORT_SECTIONS = "FCL_IMPORT_RATE_QUOTE_REPORT_SECTIONS";

export const FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_LIST = "FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_LIST";
export const FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_SUMMARY = "FCL_IMPORT_PROFIT_LOSS_BASED_ON_BOOKING_REPORT_SUMMARY";

export const FCL_IMPORT_GROSS_PL_REPORT_LIST = "FCL_IMPORT_GROSS_PL_REPORT_LIST";
export const FCL_IMPORT_GROSS_PL_REPORT_SUMMARY = "FCL_IMPORT_GROSS_PL_REPORT_SUMMARY";
